import * as types from './mutations_types.js'
export default {
  SET_TOKEN: ({commit}, token) => commit(types.SET_TOKEN, token),
  LOGIN: ({commit}, param) => commit(types.LOGIN, {data: param}),
  LOGOUT: ({commit}) => commit(types.LOGOUT),
  SET_HOT: ({commit}, hot) => commit(types.SET_HOT, hot),
  SET_ARTICLE: ({commit}, article) => commit(types.SET_ARTICLE, article),
  SET_SLIDE: ({commit}, slide) => commit(types.SET_SLIDE, slide),
  SET_SONG_TAG_LANG: ({commit}, songTagLang) => commit(types.SET_SONG_TAG_LANG, songTagLang),
  SET_SONG_TAG_TEMPO: ({commit}, songTagTempo) => commit(types.SET_SONG_TAG_TEMPO, songTagTempo),
  SET_SONG_CATEGORY: ({commit}, songCategory) => commit(types.SET_SONG_CATEGORY, songCategory),
  SET_ACTIVITY: ({commit}, activity) => commit(types.SET_ACTIVITY, activity),
  SET_SONG_LATEST: ({commit}, songLatest) => commit(types.SET_SONG_LATEST, songLatest),
  SET_SONG_SPECIAL: ({commit}, songSpecial) => commit(types.SET_SONG_SPECIAL, songSpecial),
  SET_SONG_SHARE: ({commit}, songShare) => commit(types.SET_SONG_SHARE, songShare),
  SET_PARTNER_CATEGORY: ({commit}, partnerCategory) => commit(types.SET_PARTNER_CATEGORY, partnerCategory),
  UPDATEUSER: ({commit}, param) => commit(types.UPDATEUSER, {data: param})
}



// WEBPACK FOOTER //
// ./src/store/home/actions.js